export default __webpack_public_path__ + "static/matt-bitmoji-64665f6abc664baedb1927a23c33bd40.png";